class ProductBundleOptions extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bundleReady === 'true') return;
    this.dataset.bundleReady = 'true';

    this.formId = this.dataset.productFormId;
    this.form = document.getElementById(this.formId);

    if (!this.form) return;

    this.radios = Array.from(this.querySelectorAll('[data-bundle-radio]'));
    this.items = Array.from(this.querySelectorAll('[data-bundle-option]'));
    this.hiddenState = this.querySelector('[data-bundle-selected-quantity]');

    this.ensureVariantInput();
    this.ensureQuantityInput();
    this.bindEvents();
    this.syncSelectedOption();
  }

  ensureVariantInput() {
    this.variantInput = this.form.querySelector('input[name="id"]');

    if (!this.variantInput && this.formId) {
      this.variantInput = document.querySelector(`input[name="id"][form="${this.formId}"]`);
    }
  }

  ensureQuantityInput() {
    this.quantityInput = this.form.querySelector('input[name="quantity"]');

    if (!this.quantityInput && this.formId) {
      this.quantityInput = document.querySelector(`input[name="quantity"][form="${this.formId}"]`);
    }

    if (!this.quantityInput) {
      this.quantityInput = document.createElement('input');
      this.quantityInput.type = 'hidden';
      this.quantityInput.name = 'quantity';
      this.quantityInput.value = '1';
      this.form.appendChild(this.quantityInput);
    }
  }

  bindEvents() {
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.syncSelectedOption();
      });
    });

    this.items.forEach((item) => {
      item.addEventListener('click', () => {
        const radio = item.querySelector('[data-bundle-radio]');

        if (!radio) return;

        radio.checked = true;
        this.syncSelectedOption();
      });
    });
  }

  syncSelectedOption() {
    const checkedRadio = this.querySelector('[data-bundle-radio]:checked');

    if (!checkedRadio) return;

    const currentItem = checkedRadio.closest('[data-bundle-option]');

    this.updateActiveState(currentItem);
    this.syncSelectedQuantity(checkedRadio);
    this.syncSelectedVariant(currentItem);
  }

  updateActiveState(currentItem) {
    this.items.forEach((item) => {
      item.classList.remove('is-active');
    });

    if (currentItem) {
      currentItem.classList.add('is-active');
    }
  }

  syncSelectedQuantity(checkedRadio) {
    if (!checkedRadio || !this.quantityInput) return;

    const qty = checkedRadio.value || '1';

    this.quantityInput.value = qty;
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

    if (this.hiddenState) {
      this.hiddenState.value = qty;
    }
  }

  syncSelectedVariant(currentItem) {
    if (!currentItem || !this.variantInput) return;

    const variantId = currentItem.dataset.variantId;

    if (!variantId) return;

    this.variantInput.value = variantId;
    this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('product-bundle-options')) {
  customElements.define('product-bundle-options', ProductBundleOptions);
}